import React from 'react';

function Article(props: object) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.3125 5.625H4.6875C4.16973 5.625 3.75 6.04473 3.75 6.5625V23.4375C3.75 23.9553 4.16973 24.375 4.6875 24.375H25.3125C25.8303 24.375 26.25 23.9553 26.25 23.4375V6.5625C26.25 6.04473 25.8303 5.625 25.3125 5.625Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 11.25H20.625"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 15H20.625"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 18.75H20.625"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Article;
